<template>
  <DashboardWidgetGauge class="widget-zed-score" :loading="loading" title="Zed Score" :min="min" :max="max" :value="value" />
</template>

<script>

export default {
  name: 'dashboard-widget-zed-score',
  components: {
    DashboardWidgetGauge: () => import('../BaseWidgets/DashboardWidgetGauge'),
  },
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 6,
    },
    value: {
      type: Number,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
};

</script>
